import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", {
  id: "form",
  class: "h40 d-flex align-items-center bg-gradient2 section-padding"
}, null, -1)
const _hoisted_2 = {
  id: "process",
  class: "bg-gray section-padding-b"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row flex justify-content-center" }
const _hoisted_5 = { class: "col-sm-8 col-lg-7 col-md-7" }
const _hoisted_6 = { class: "card-step card-form" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header bg-purple text-white" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h6" }, " Sin importar tus respuestas, encontraremos un préstamo para ti. Responde honestamente a estas preguntas ")
], -1)
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"center"},
  class: "my-5"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-4 justify-content-center"
}
const _hoisted_10 = { class: "m-0 m-auto w-9" }
const _hoisted_11 = { class: "p-fluid p-formgrid pt-4 p-grid px-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "font-weight-bold contact" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "font-weight-bold text-black text-base" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 3,
  class: "px-xl-5 px-lg-4 ml-lg-4"
}
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = { key: 7 }
const _hoisted_25 = { key: 8 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "px-lg-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Para más información, consulte nuestro ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" aviso de privacidad. ")
const _hoisted_31 = {
  key: 0,
  class: "px-4 pb-4"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col button-card-footer" }
const _hoisted_35 = { class: "col button-card-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_Steps = _resolveComponent("Steps")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TypeText = _resolveComponent("TypeText")!
  const _component_TypePhone = _resolveComponent("TypePhone")!
  const _component_TypeEmail = _resolveComponent("TypeEmail")!
  const _component_TypeSwitch = _resolveComponent("TypeSwitch")!
  const _component_TypeRadioButton = _resolveComponent("TypeRadioButton")!
  const _component_TypeYesNoButton = _resolveComponent("TypeYesNoButton")!
  const _component_TypeDropDown = _resolveComponent("TypeDropDown")!
  const _component_TypeDate = _resolveComponent("TypeDate")!
  const _component_TypeCheck = _resolveComponent("TypeCheck")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_spinner, {
                      text: "Estamos procesando tu solicitud, espera un momento.",
                      color: _ctx.spinnerColor,
                      textColor: _ctx.spinnerTextColor
                    }, null, 8, ["color", "textColor"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Steps, { model: _ctx.items }, null, 8, ["model"]),
                      _createVNode(_component_router_view)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionnaire, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    (!_ctx.loading && _ctx.currentStep === item.step)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("h4", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && _ctx.currentStep === item.step)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answers, (itemanswer) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "answer mb-1",
                              key: itemanswer.id
                            }, [
                              _createElementVNode("h5", {
                                class: _normalizeClass(["mt-2 text-center", [
                          itemanswer.key === 'termsandconditions'
                            ? 'block'
                            : 'hidden',
                        ]])
                              }, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(item.details), 1)
                              ], 2),
                              (itemanswer.component === 'text')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_TypeText, {
                                      class: "pt-2",
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      "validation-label": "Este campo es obligatorio",
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'phone')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_TypePhone, {
                                      class: "pt-2",
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      "validation-label": 
                            `Campo incorrecto. Ingresa un número de ${_ctx.phoneLength} dígitos.`
                          ,
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      value: itemanswer.value,
                                      minLength: _ctx.phoneLength,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "validation-label", "isRequired", "isSubmitted", "value", "minLength", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'email')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_TypeEmail, {
                                      class: "pt-2",
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      "validation-label": "Campo incorrecto. Ingresa un correo válido.",
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'switch')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_TypeSwitch, {
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      catalog: itemanswer.catalog,
                                      onGetValue: _ctx.setValue,
                                      origin: "Steps"
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "catalog", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'radiobutton')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_TypeRadioButton, {
                                      label: itemanswer.name,
                                      "answer-key": itemanswer.key,
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      catalog: itemanswer.catalog,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["label", "answer-key", "isRequired", "isSubmitted", "catalog", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                          itemanswer.component === 'yesnobutton' &&
                            item.required
                        )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_TypeYesNoButton, {
                                      label: itemanswer.name,
                                      "answer-key": itemanswer.key,
                                      "validation-label": "Este campo es obligatorio.",
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["label", "answer-key", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'dropdown')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createVNode(_component_TypeDropDown, {
                                      class: "pt-2",
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      "validation-label": "Campo incorrecto. Selecciona una opción.",
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      catalog: itemanswer.catalog,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "catalog", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'date')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(_component_TypeDate, {
                                      class: "pt-2",
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'check')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(_component_TypeCheck, {
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      isRequired: item.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue,
                                      catalog: itemanswer.catalog,
                                      maxAnswers: itemanswer.maxAnswers
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue", "catalog", "maxAnswers"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("h5", {
                                class: _normalizeClass(["mt-1 text-center h6", [
                          itemanswer.key === 'privacyNotice'
                            ? 'block'
                            : 'hidden',
                        ]])
                              }, [
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("small", null, [
                                    _createTextVNode(" Acepto recibir notificaciones, comunicaciones y ofertas comerciales de " + _toDisplayString(_ctx.name) + ". ", 1),
                                    _hoisted_28,
                                    _hoisted_29,
                                    _createVNode(_component_router_link, { to: { name: 'Privacy' } }, {
                                      default: _withCtx(() => [
                                        _hoisted_30
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_Button, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.to(_ctx.currentStep - 1))),
                            iconPos: "left",
                            label: "Regresar",
                            icon: "fas fa-angle-double-left",
                            class: "surface-50 border-0 p-button-rounded font-weight-bold text-900"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_Button, {
                            iconPos: "right",
                            onClick: _ctx.register,
                            label: "Siguiente",
                            icon: "fas fa-angle-double-right",
                            class: "bg-yellow-500 border-yellow-500 p-button-raised p-button-rounded font-weight-bold text-900"
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}